import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate, usd } from "@/lib/format";

export const UserUsage = ({ user }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/admin/users/${user.id}/usage`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [user.id, user.ai_calls]);

  return (
    <div className="border-t border-[var(--rf-ink)] pt-4" data-testid="admin-user-usage">
      <h3 className="rf-mono text-[10px] tracking-[0.3em] uppercase mb-3">Consumo IA</h3>
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div><p className="text-xl font-black rf-red" data-testid="admin-user-usage-cost">{usd(user.cost, 4)}</p><p className="text-xs text-[var(--rf-grey)]">credito speso</p></div>
        <div><p className="text-xl font-black" data-testid="admin-user-usage-calls">{user.ai_calls}</p><p className="text-xs text-[var(--rf-grey)]">richieste IA</p></div>
        <div><p className="text-xl font-black">{user.tokens.toLocaleString("it-IT")}</p><p className="text-xs text-[var(--rf-grey)]">token</p></div>
      </div>
      {rows.length === 0 ? <p className="text-sm text-[var(--rf-grey)]">Nessun consumo registrato.</p> : (
        <ul className="max-h-56 overflow-y-auto" data-testid="admin-user-usage-list">
          {rows.map((r) => (
            <li key={r.id} className="flex items-baseline gap-3 py-1.5 border-b rf-line text-xs">
              <span className="w-28 shrink-0 rf-mono text-[10px] text-[var(--rf-grey)]">{fmtDate(r.created_at)}</span>
              <span className="flex-1 min-w-0 truncate">{r.kind === "analysis" ? "Analisi" : `Prompt ${r.tool}`} · {r.filename || "—"}</span>
              <span className="rf-mono">{usd(r.cost, 4)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
